"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("@seneca/errors");
/**
 * Thrown when the number of retries has been met or exceeded, this indicates
 * an issue with the backend service
 * @param {string} method
 * @param {string} url
 * @param {Error} fetchError (optional)
 * @param {string} body (optional)
 * @param {number} status (optional)
 * @param {string} correlationId (optional)
 */
class RequestLimitExceeded extends errors_1.ExtendableError {
    constructor({ method, url, fetchError, body, status, correlationId }) {
        super(`Retry limit hit for: ${method} - ${url}` +
            `${fetchError ? ' - ' + fetchError.toString() : ''}` +
            `${status ? ` - ${status}` : ''}` +
            `${correlationId ? ' - correlationId: ' + correlationId : ''}` +
            `${body
                ? ` - body: ${body.length > 500 ? body.substring(0, 500) + '...' : body}`
                : ''}`);
        this.method = method;
        this.url = url;
        this.fetchError = fetchError;
        this.body = body;
        this.correlationId = correlationId;
    }
}
exports.default = RequestLimitExceeded;
